import React from 'react'
import { useTranslation } from 'react-i18next'

/** useErrorLaunder will translate error keys when the key is present, or pass back the original text
 * this is usefull for scenario's where you're not sure if the error has already been translated
 */
export const useErrorLaunder = (errorText?: string): string | null => {
  const { t, i18n } = useTranslation()

  return React.useMemo(() => {
    if (!errorText) return null
    return i18n.exists(errorText) ? t(errorText) : errorText
  }, [errorText, i18n, t])
}
